export const ADDRESS_DETAILS_FORM = {
	label: 'settings.address.details.heading',
	fields: [
		{
			name: 'address.addressLineNo1',
			label: 'settings.address.addressline.label',
			value: 'addressLineNo1',
			component: 'text'
		},
		{
			name: 'address.city',
			label: 'settings.address.town.label',
			component: 'text',
			value: 'city'
		},
		{
			name: 'address.state',
			label: 'settings.address.state.label',
			component: 'text',
			value: 'state',
			isCountryUSA: true
		},
		{
			name: 'address.postCode',
			label: 'settings.address.postcode.label',
			component: 'text',
			value: 'postCode'
		},
		{
			name: 'address.country',
			label: 'settings.address.country.label',
			component: 'select',
			value: 'country'
		}
	]
};
